var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46 13.02-3.309 8.902H26.807L23.5 13.02H46Z",
    fill: "#00AF7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.86 44.184-8.78-.004-8.273-22.258-3.309-8.903-3.308 8.903-8.274 22.262H3.132l8.459-22.261 3.382-8.904L18.778 3h9.439l3.807 10.02 3.382 8.902 8.453 22.262Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.498 13.02-3.308 8.902H4.309L1 13.02h22.498Zm4.963 13.354 3.309 8.903H4.309L1 26.374h27.461Zm17.539 0-3.309 8.903H40.48l-3.382-8.903H46Z",
    fill: "#00AF7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.0d948ad800597341b1499c10a441f212.svg";
export { ForwardRef as ReactComponent };